import(/* webpackMode: "eager" */ "/vercel/path0/app/percentage-calculator/page.tsx");
